// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"0a424ad2","703":"2bde6ed7","787":"ac9a36e1"}[chunkId] + ".chunk.js";
};